var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid fixed-bottom bg-danger text-center text-white p-1"},[_vm._v(" © All Rights Reserved! - "+_vm._s(new Date().getFullYear())+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }